<template lang="pug">
.keys
  header.keys__hero
    .keys__hero-grid
    .keys__hero-glow.keys__hero-glow--blue
    .keys__hero-glow.keys__hero-glow--red
    .keys__hero-inner
      p.keys__eyebrow
        span.keys__eyebrow-pip
        | Chaveamento
      h1.keys__title Chaves do Torneio
      p.keys__sub Acompanhe o avanço da dupla eliminação: chave dos vencedores, repescagem e a grande final.
      .keys__event-badge(v-if="getCurrentEvent")
        span.keys__event-label Evento
        span.keys__event-name {{ getCurrentEvent.name }}

  .keys__wrap
    .keys__controls
      Select.select-category(
        defaultText="Selecionar Categoria"
        :options="takeCategories"
        :value="categorySelected"
        type='drop'
        @emit="doSetCategorySelected"
      )
      button.keys__generate-btn(
        v-if="isAdmin && categorySelected && !hasKeys && !groupsEnabled"
        @click="doGenerateKeys"
      ) Gerar Chaves
      button.keys__generate-btn.keys__generate-btn--regen(
        v-if="isAdmin && categorySelected && hasKeys && !hasResults && !groupsEnabled"
        @click="doRegenKeys"
      ) Regerar Chaves
      .keys__group-hint(v-if="isAdmin && categorySelected && groupsEnabled")
        span.keys__group-hint-ic 🧩
        span Esta categoria usa fase de grupos: gere a chave pela tela Grupos (com os classificados).
      .keys__locked(
        v-if="isAdmin && categorySelected && hasKeys && hasResults"
        title="A regeração apagaria as lutas já realizadas"
      )
        span.keys__locked-icon 🔒
        span Chaves bloqueadas: já há lutas realizadas
      button.keys__generate-btn.keys__schedule-btn(
        v-if="canManage"
        @click="doShowSchedule"
      ) Agendar lutas

    .keys__arena(
      v-if="categorySelected && takeWinnersKeys[0].length"
    )
      .keys__col(v-if="hasLosers")
        h2.keys__col-title.keys__col-title--losers
          span.keys__col-dot
          | Losers
        TournamentBrackets(
          side="Left"
          :bracketSize="takeLosersKeys[0].length"
          :items="takeLosersKeys"
          :wins="takeLosersWins"
        )

      .keys__final(v-if="getCurrentKeys.grand_final")
        h2.keys__final-title
          span.keys__final-trophy 🏆
          | Grande Final
        .keys__final-match
          .keys__final-side
            span.keys__final-origin Camp. Losers
            .keys__final-robot.keys__final-robot--lb(:class="{ 'keys__final-robot--champion': getCurrentKeys.grand_final_w === 1 }")
              span(:class="!getCurrentKeys.grand_final[1] ? 'tbd' : ''") {{ getCurrentKeys.grand_final[1] || '-' }}
          span.keys__final-vs VS
          .keys__final-side
            span.keys__final-origin Camp. Winners
            .keys__final-robot.keys__final-robot--wb(:class="{ 'keys__final-robot--champion': getCurrentKeys.grand_final_w === 0 }")
              span(:class="!getCurrentKeys.grand_final[0] ? 'tbd' : ''") {{ getCurrentKeys.grand_final[0] || '-' }}
        .keys__final-champion(:class="{ 'keys__final-champion--decided': grandFinalChampion }")
          span.keys__final-champion-ic 🏆
          span.keys__final-champion-txt
            span.keys__final-champion-label Campeão
            span.keys__final-champion-name(:class="{ 'keys__final-champion-name--tbd': !grandFinalChampion }") {{ grandFinalChampion || 'A definir' }}
        .keys__final-reset(v-if="getCurrentKeys.bracket_reset")
          span.keys__final-reset-label Reset do Bracket
          .keys__final-match
            .keys__final-side
              .keys__final-robot.keys__final-robot--lb
                span {{ getCurrentKeys.bracket_reset[1] || '-' }}
            span.keys__final-vs VS
            .keys__final-side
              .keys__final-robot.keys__final-robot--wb
                span {{ getCurrentKeys.bracket_reset[0] || '-' }}

      .keys__col
        h2.keys__col-title.keys__col-title--winners
          span.keys__col-dot
          | Winners
        TournamentBrackets(
          side="Right"
          :bracketSize="takeWinnersKeys[0].length"
          :items="takeWinnersKeys"
          :wins="takeWinnersWins"
        )

    .keys__empty(
      v-else-if="!categorySelected"
    )
      span.keys__empty-ic 🗂️
      h3.keys__empty-title Selecione uma categoria
      p.keys__empty-text Escolha uma categoria acima para visualizar o chaveamento.

    .keys__empty(
      v-else
    )
      span.keys__empty-ic 🕸️
      h3.keys__empty-title Sem chaves geradas
      p.keys__empty-text Essa categoria ainda não possui chaves geradas.

  Modal(
    :visible="showSchedule"
    @close="showSchedule = false"
    @emit="showSchedule = false"
  )
    .kmodal
      h3.kmodal__title Agendar lutas
      p.kmodal__hint A 1ª luta começa no horário definido; as demais seguem a regra dos 40min de descanso por robô, {{ schedSlot }} min entre lutas na mesma arena. Vale para o evento todo.
      label.kmodal__label Data
      input.kmodal__input(type="date" v-model="schedDate")
      label.kmodal__label Horário de início
      input.kmodal__input(type="time" v-model="schedTime")
      label.kmodal__label Minutos entre lutas na arena
      input.kmodal__input(type="number" min="1" v-model.number="schedSlot")
      .kmodal__lunch
        label.kmodal__check
          input(type="checkbox" v-model="schedLunchOn")
          span Reservar intervalo de almoço
        template(v-if="schedLunchOn")
          label.kmodal__label Início do almoço
          input.kmodal__input(type="time" v-model="schedLunchTime")
          label.kmodal__label Duração (minutos)
          input.kmodal__input(type="number" min="5" step="5" v-model.number="schedLunchMin")
          p.kmodal__hint Nenhuma luta é marcada nesse intervalo, e ele aparece na agenda.
      p.kmodal__err(v-if="schedError") {{ schedError }}
      p.kmodal__ok(v-if="schedOk") {{ schedOk }}
      .kmodal__foot
        Button(text="Gerar agenda" border="base" @click="doScheduleFights")
</template>

<script>

import {
  mapGetters,
  mapActions
} from 'vuex'

import {
  TournamentBrackets,
  Select,
  Button
} from '@/components/atoms'

import {
  Modal
} from '@/components/molecules'

export default {
  name: 'Keys',
  props: {},
  data () {
    return {
      // restaura a ultima categoria selecionada (persistida no vuex) p/ a chave
      // reaparecer ao reentrar na tela, sem precisar re-selecionar nem dar refresh
      categorySelected: this.$store.getters['fights/getKeysCategoryId'] || '',
      groupsEnabled: false,
      showSchedule: false,
      schedDate: '',
      schedTime: '',
      schedSlot: 5,
      schedLunchOn: false,
      schedLunchTime: '12:00',
      schedLunchMin: 60,
      schedError: '',
      schedOk: ''
    }
  },
  created () {
    this.setCategories()
    this.setEvents().then(() => {
      if (this.getCurrentEventId) this.setEventSummary(this.getCurrentEventId)
      // recarrega a chave da categoria lembrada (reflete lutas encerradas por outro operador)
      if (this.categorySelected) {
        this.setCategoryKeys({ event_id: this.getCurrentEventId, category_id: this.categorySelected })
        this.loadGroupsEnabled()
      }
    })
  },
  components: {
    TournamentBrackets,
    Select,
    Button,
    Modal
  },
  computed: {
    ...mapGetters('categories', [
      'getCategories'
    ]),
    ...mapGetters('fights', [
      'getCurrentKeys'
    ]),
    ...mapGetters('events', [
      'getCurrentEventId',
      'getCurrentEvent',
      'getCurrentEventArenaId',
      'getEventSummary'
    ]),
    // Só as categorias DO EVENTO (ver Groups.vue). Fallback: todas, se o resumo
    // ainda não carregou.
    takeCategories () {
      const doEvento = (this.getEventSummary || [])
        .filter(c => c.category_id)
        .map(c => ({ text: c.category_name, value: c.category_id }))
      if (doEvento.length) return doEvento
      return [...this.getCategories].map(category => { return { text: category.name, value: category.id } })
    },
    hasKeys () {
      return this.getCurrentKeys.winners && this.getCurrentKeys.winners.length > 0
    },
    takeWinnersKeys () {
      if (this.getCurrentKeys.winners && this.getCurrentKeys.winners.length) {
        return this.getCurrentKeys.winners
      }
      return [[]]
    },
    isAdmin () {
      const roles = this.$store.getters['users/getUser'].roles
      return Array.isArray(roles) && roles.includes(1)
    },
    canManage () {
      // agendar: admin do evento (1) ou Organizador (6) — mesma regra do backend
      const roles = this.$store.getters['users/getUser'].roles
      return Array.isArray(roles) && (roles.includes(1) || roles.includes(6))
    },
    hasLosers () {
      return !!(this.getCurrentKeys.losers && this.getCurrentKeys.losers.length > 0)
    },
    takeLosersKeys () {
      if (this.getCurrentKeys.losers && this.getCurrentKeys.losers.length) {
        return this.getCurrentKeys.losers
      }
      return [[]]
    },
    takeWinnersWins () {
      return this.getCurrentKeys.winners_w || []
    },
    takeLosersWins () {
      return this.getCurrentKeys.losers_w || []
    },
    grandFinalChampion () {
      const gf = this.getCurrentKeys.grand_final
      const w = this.getCurrentKeys.grand_final_w
      if (!gf || (w !== 0 && w !== 1)) return ''
      return gf[w]
    },
    // true se houver ao menos 1 luta REAL já realizada (vencedor definido com os
    // dois robôs presentes). Byes (1 robô) nao contam, entao chave recem-gerada
    // ainda permite regerar; apos a 1a luta de verdade, a geracao e bloqueada.
    hasResults () {
      const k = this.getCurrentKeys
      const decidedReal = (items, wins) => {
        if (!Array.isArray(items) || !Array.isArray(wins)) return false
        for (let r = 0; r < items.length; r++) {
          const round = items[r] || []
          const wRound = wins[r] || []
          for (let m = 0; m < round.length; m++) {
            const match = round[m]
            const w = wRound[m]
            if ((w === 0 || w === 1) && match && match[0] && match[1]) return true
          }
        }
        return false
      }
      if (decidedReal(k.winners, k.winners_w)) return true
      if (decidedReal(k.losers, k.losers_w)) return true
      const gf = k.grand_final
      const gw = k.grand_final_w
      if ((gw === 0 || gw === 1) && gf && gf[0] && gf[1]) return true
      return false
    }
  },
  methods: {
    ...mapActions('categories', [
      'setCategories'
    ]),
    ...mapActions('fights', [
      'setCategoryKeys',
      'setGenerateKeys',
      'setScheduleFights',
      'fetchGroupStage'
    ]),
    loadGroupsEnabled () {
      if (!this.categorySelected) { this.groupsEnabled = false; return }
      this.fetchGroupStage({ event_id: this.getCurrentEventId, category_id: this.categorySelected })
        .then(res => { this.groupsEnabled = !!(res && res.enabled) })
    },
    doShowSchedule () {
      this.schedError = ''
      this.schedOk = ''
      this.showSchedule = true
    },
    doScheduleFights () {
      this.schedError = ''
      this.schedOk = ''
      if (!this.schedDate || !this.schedTime) {
        this.schedError = 'Informe a data e o horário de início.'
        return
      }
      const slot = this.schedSlot && this.schedSlot >= 1 ? this.schedSlot : 5
      // wall-clock rotulado Z, mesmo formato usado na tela de Lutas
      const startAt = `${this.schedDate}T${this.schedTime}:00.000Z`
      const payload = {
        event_id: this.getCurrentEventId,
        start_at: startAt,
        slot_minutes: slot
      }
      if (this.schedLunchOn && this.schedLunchTime && this.schedLunchMin > 0) {
        if (this.schedLunchTime <= this.schedTime) {
          this.schedError = 'O almoço precisa começar depois do horário de início.'
          return
        }
        payload.lunch_start = `${this.schedDate}T${this.schedLunchTime}:00.000Z`
        payload.lunch_minutes = this.schedLunchMin
      }
      this.setScheduleFights(payload).then(response => {
        if (response && response.success) {
          this.schedOk = `Agenda gerada: ${response.scheduled} luta(s) agendada(s).`
          if (this.categorySelected) {
            this.setCategoryKeys({ event_id: this.getCurrentEventId, category_id: this.categorySelected })
          }
        } else {
          this.schedError = (response && response.error) || 'Não foi possível gerar a agenda (verifique a permissão e se as chaves já foram geradas).'
        }
      })
    },
    ...mapActions('events', [
      'setEvents',
      'setEventSummary'
    ]),
    doSetCategorySelected (e) {
      this.categorySelected = e.value
      this.$store.commit('fights/keysCategoryId', e.value) // persiste a selecao p/ reentrada
      this.setCategoryKeys({ event_id: this.getCurrentEventId, category_id: this.categorySelected })
      this.loadGroupsEnabled()
    },
    doGenerateKeys () {
      // captura event_id/category ANTES do await: getCurrentEventId e getter derivado
      // (fallback "evento ativo ou ultimo") e pode mudar durante a chamada
      const eventId = this.getCurrentEventId
      const categoryId = this.categorySelected
      this.setGenerateKeys({
        event_id: eventId,
        category_id: categoryId,
        arena_id: this.getCurrentEventArenaId,
        admin_id: this.$store.getters['users/getUser'].id
      }).then((ok) => {
        // so recarrega a chave se a geracao SUCEDEU, e com o MESMO event_id/category
        if (ok !== false) {
          this.setCategoryKeys({ event_id: eventId, category_id: categoryId })
        }
      })
    },
    doRegenKeys () {
      if (this.hasResults) {
        window.alert('Não é possível regerar as chaves: já existem lutas realizadas nesta categoria.')
        return
      }
      if (!window.confirm('Isso irá apagar todas as lutas geradas para essa categoria e criar um novo bracket. Deseja continuar?')) return
      this.doGenerateKeys()
    }
  },
  filters: {},
  watch: {
    getCurrentEventId (newId) {
      if (newId) this.setEventSummary(newId) // categorias mudam com o evento
      if (this.categorySelected) {
        this.setCategoryKeys({ event_id: this.getCurrentEventId, category_id: this.categorySelected })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  $blue: #287AED
  $blue-dark: #0F4FA8
  $red: #DD3434
  $red-dark: #B0231F
  $gold: #F9A825
  $ink: #0B0E14
  $muted: #5C6673
  $line: rgba(11, 14, 20, 0.10)
  $paper: #FFFFFF
  $page: #F2F4F8
  $display: 'Saira Condensed', 'Lato', sans-serif
  $mono: 'Space Mono', 'Lato', monospace

  .keys
    color: $ink
    background: $page
    min-height: calc(100vh - 64px)
    overflow-x: hidden // segura o scroll horizontal da arena full-bleed

    *
      box-sizing: border-box

    // ---------- HERO ----------
    &__hero
      position: relative
      overflow: hidden
      isolation: isolate
      padding: 30px 0 40px
      background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
      color: #fff

    &__hero-grid
      position: absolute
      inset: 0
      background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
      background-size: 42px 42px
      mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
      -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
      z-index: -2

    &__hero-glow
      position: absolute
      width: 360px
      height: 360px
      border-radius: 50%
      filter: blur(110px)
      opacity: 0.5
      z-index: -1
      &--blue
        background: $blue
        top: -170px
        left: -90px
      &--red
        background: $red
        bottom: -190px
        right: -70px

    &__hero-inner
      position: relative
      max-width: 1240px
      margin: 0 auto
      padding: 0 24px
      > *
        animation: keys-rise .55s cubic-bezier(.2, .7, .2, 1) both
      .keys__title
        animation-delay: .06s
      .keys__sub
        animation-delay: .12s
      .keys__event-badge
        animation-delay: .18s

    &__eyebrow
      display: inline-flex
      align-items: center
      gap: 10px
      font-family: $mono
      text-transform: uppercase
      letter-spacing: 0.22em
      font-size: 12px
      font-weight: 700
      color: rgba(255, 255, 255, 0.7)
      margin: 0 0 12px

    &__eyebrow-pip
      width: 8px
      height: 8px
      border-radius: 50%
      background: linear-gradient(135deg, #5AA0FF, $red)
      box-shadow: 0 0 0 4px rgba(90, 160, 255, 0.15)

    &__title
      font-family: $display
      font-size: 44px
      line-height: 1.02
      font-weight: 800
      letter-spacing: -0.01em
      margin: 0

    &__sub
      max-width: 560px
      margin: 12px 0 0
      font-size: 15px
      line-height: 1.5
      color: rgba(255, 255, 255, 0.72)

    &__event-badge
      display: inline-flex
      align-items: center
      gap: 10px
      margin-top: 18px
      padding: 8px 16px
      border-radius: 999px
      background: rgba(255, 255, 255, 0.07)
      border: 1px solid rgba(255, 255, 255, 0.14)

    &__event-label
      font-family: $mono
      font-size: 10px
      text-transform: uppercase
      letter-spacing: 0.14em
      color: rgba(255, 255, 255, 0.55)

    &__event-name
      font-family: $display
      font-size: 16px
      font-weight: 700
      color: #fff

    // ---------- CORPO ----------
    &__wrap
      max-width: 1240px
      margin: 0 auto
      padding: 28px 24px 64px

    &__controls
      display: flex
      align-items: flex-start
      flex-wrap: wrap
      gap: 16px
      margin-bottom: 24px
      .select-category
        min-width: 260px
        // harmoniza o Select (atom) com a barra de controles desta tela
        ::v-deep .select__default
          .text
            border-color: $line
            border-radius: 10px 0 0 10px
            height: 48px
            font-family: $display
            font-weight: 600
          .icon
            border-color: $line
            border-radius: 0 10px 10px 0
            height: 48px
            background: $paper
        ::v-deep .select__options .option
          border-color: $line
          border-radius: 10px

    &__generate-btn
      padding: 0 24px
      height: 48px
      background: linear-gradient(140deg, $red, $red-dark)
      color: white
      border: none
      border-radius: 10px
      font-family: $display
      font-size: 16px
      font-weight: 700
      letter-spacing: 0.02em
      cursor: pointer
      white-space: nowrap
      box-shadow: 0 6px 16px rgba(221, 52, 52, 0.28)
      transition: transform .16s ease, box-shadow .16s ease, filter .16s ease
      &:hover
        transform: translateY(-1px)
        filter: brightness(1.05)
        box-shadow: 0 8px 22px rgba(221, 52, 52, 0.36)
      &--regen
        background: linear-gradient(140deg, #F57C00, #E65100)
        box-shadow: 0 6px 16px rgba(245, 124, 0, 0.28)
        &:hover
          box-shadow: 0 8px 22px rgba(245, 124, 0, 0.36)

    &__schedule-btn
      background: linear-gradient(140deg, $blue, $blue-dark)
      box-shadow: 0 6px 16px rgba(40, 122, 237, 0.28)
      &:hover
        box-shadow: 0 8px 22px rgba(40, 122, 237, 0.36)

    &__locked
      display: flex
      align-items: center
      gap: 8px
      height: 48px
      padding: 0 18px
      border: 1px solid #EAC94A
      background: #FFF8E1
      color: #8D6E00
      border-radius: 10px
      font-size: 14px
      font-weight: 600
      white-space: nowrap
      &-icon
        font-size: 16px

    &__group-hint
      display: flex
      align-items: center
      gap: 8px
      min-height: 48px
      padding: 10px 18px
      border: 1px solid rgba(40, 122, 237, 0.4)
      background: rgba(40, 122, 237, 0.08)
      color: $blue-dark
      border-radius: 10px
      font-size: 14px
      font-weight: 600
      &-ic
        font-size: 16px

    // arena full-bleed (rompe o container) — o bracket é largo, então rola
    // na horizontal usando a largura toda da janela, sem ficar preso num quadro
    &__arena
      width: 100vw
      margin-left: calc(50% - 50vw)
      overflow-x: auto
      overflow-y: hidden
      display: flex
      flex-direction: row
      align-items: center
      justify-content: safe center
      gap: 8px
      padding: 12px 40px 20px
      // scrollbar discreta
      scrollbar-width: thin
      scrollbar-color: rgba(11, 14, 20, 0.25) transparent
      &::-webkit-scrollbar
        height: 10px
      &::-webkit-scrollbar-thumb
        background: rgba(11, 14, 20, 0.2)
        border-radius: 999px
        border: 2px solid transparent
        background-clip: content-box
      &::-webkit-scrollbar-thumb:hover
        background: rgba(11, 14, 20, 0.35)
        background-clip: content-box

    &__col
      display: flex
      flex-direction: column

    &__col-title
      display: inline-flex
      align-items: center
      align-self: center
      gap: 8px
      font-family: $display
      font-size: 14px
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.1em
      color: $ink
      margin: 0 0 18px
      padding: 6px 16px
      border-radius: 999px
      background: $page
      border: 1px solid $line

    &__col-dot
      width: 9px
      height: 9px
      border-radius: 50%

    &__col-title--winners &__col-dot
      background: $blue
    &__col-title--losers &__col-dot
      background: $red

    // ---------- ESTADOS VAZIOS ----------
    &__empty
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      text-align: center
      width: 100%
      padding: 72px 24px
      background: $paper
      border: 1px dashed rgba(11, 14, 20, 0.16)
      border-radius: 16px

    &__empty-ic
      font-size: 44px
      margin-bottom: 12px
      opacity: 0.85

    &__empty-title
      font-family: $display
      font-size: 22px
      font-weight: 700
      margin: 0 0 6px

    &__empty-text
      font-size: 14px
      color: $muted
      margin: 0

    // ---------- GRANDE FINAL ----------
    &__final
      display: flex
      flex-direction: column
      align-items: center
      flex-shrink: 0
      align-self: center
      margin: 0 6px

    &__final-title
      display: inline-flex
      align-items: center
      gap: 8px
      font-family: $display
      font-size: 15px
      font-weight: 800
      text-transform: uppercase
      letter-spacing: 0.08em
      color: $ink
      white-space: nowrap
      margin-bottom: 14px

    &__final-trophy
      font-size: 18px

    &__final-match
      display: flex
      flex-direction: row
      align-items: center
      gap: 12px
      padding: 16px 14px
      border: 1px solid rgba(249, 168, 37, 0.6)
      border-radius: 14px
      background: linear-gradient(180deg, #FFFDF6, #FFF8E8)
      box-shadow: 0 8px 24px rgba(249, 168, 37, 0.18)

    &__final-side
      display: flex
      flex-direction: column
      align-items: center
      gap: 6px

    &__final-origin
      font-family: $mono
      font-size: 9px
      text-transform: uppercase
      letter-spacing: 0.08em
      color: $muted
      white-space: nowrap

    &__final-robot
      border: 1px solid $line
      border-radius: 8px
      padding: 10px 14px
      min-width: 110px
      text-align: center
      font-family: $display
      font-size: 15px
      font-weight: 600
      background: white
      position: relative
      .tbd
        color: #AEB7C4
        font-family: $mono
        font-size: 11px
        font-weight: 400
      &--lb
        border-left: 4px solid $red
        &::before
          content: ""
          position: absolute
          left: -22px
          top: 50%
          width: 20px
          border-bottom: 2px solid #C3CBD8
      &--wb
        border-right: 4px solid $blue
        &::after
          content: ""
          position: absolute
          right: -22px
          top: 50%
          width: 20px
          border-bottom: 2px solid #C3CBD8
      &--champion
        border-color: $gold
        background: #FFF3CE
        color: #7A5C00
        font-weight: 800
        box-shadow: 0 0 0 3px rgba(249, 168, 37, 0.4)

    // slot do campeão: sempre visível (placeholder "A definir" até a final ser
    // decidida; vira medalha dourada com o nome quando há campeão)
    &__final-champion
      display: inline-flex
      align-items: center
      gap: 10px
      margin-top: 16px
      padding: 10px 18px
      min-width: 180px
      background: $page
      border: 1px dashed rgba(11, 14, 20, 0.2)
      border-radius: 999px
      transition: background .2s ease, border-color .2s ease, box-shadow .2s ease
      &--decided
        background: linear-gradient(140deg, #FFF3CE, #FDE9A8)
        border: 1px solid $gold
        box-shadow: 0 6px 18px rgba(249, 168, 37, 0.28)
      &-ic
        font-size: 20px
        filter: grayscale(1)
        opacity: 0.4
      &--decided &-ic
        filter: none
        opacity: 1
      &-txt
        display: flex
        flex-direction: column
        align-items: flex-start
        line-height: 1.1
      &-label
        font-family: $mono
        font-size: 9px
        text-transform: uppercase
        letter-spacing: 0.12em
        color: $muted
      &--decided &-label
        color: #9A7A1A
      &-name
        font-family: $display
        font-size: 16px
        font-weight: 800
        color: #7A5C00
        &--tbd
          color: #AEB7C4
          font-weight: 600

    &__final-vs
      font-family: $display
      font-size: 14px
      font-weight: 800
      color: $muted

    &__final-reset
      margin-top: 16px
      display: flex
      flex-direction: column
      align-items: center
      &-label
        font-family: $mono
        font-size: 10px
        text-transform: uppercase
        letter-spacing: 0.08em
        color: $muted
        margin-bottom: 8px

  .kmodal
    padding: 32px 30px 28px
    display: flex
    flex-direction: column
    &__title
      font-family: $display
      font-weight: 700
      text-transform: uppercase
      font-size: 22px
      margin: 0 0 10px
      color: $ink
    &__hint
      font-size: 13px
      color: $muted
      margin: 0 0 8px
    &__label
      font-size: 13px
      font-weight: 600
      color: $muted
      margin: 12px 0 6px
    &__input
      border: none
      border-bottom: 1.5px solid $line
      padding: 8px 2px
      font-size: 15px
      font-family: inherit
      color: $ink
      &:focus
        outline: none
        border-color: $blue
    &__err
      font-size: 13px
      color: $red
      margin: 12px 0 0
    &__ok
      font-size: 13px
      color: #2E7D32
      margin: 12px 0 0
    &__foot
      margin-top: 24px

  @keyframes keys-rise
    from
      opacity: 0
      transform: translateY(14px)
    to
      opacity: 1
      transform: translateY(0)
</style>
